export default "__VITE_ASSET__BUFrysQ4__"